<template>
  <div>
    <mds-section
      border="tertiary"
      bold
      :size="8"
      :title="translate('annuityBenefitAndRiderOptions')"
    >
      <template v-slot:mds-section-actions>
        <mds-switch v-model="includeAnnuity" hidden-label>
          {{ translate('include') }}
        </mds-switch>
      </template>
      <template v-if="includeAnnuity">
        <p :class="$style['annuity-explanation']">
          {{ translate('annuityExplanation') }}
        </p>
        <div :class="$style['annuity-options-table']">
          <mds-table>
            <mds-thead>
              <mds-th>{{ translate('contract') }} </mds-th>
              <mds-th right-aligned style="width: 100px;"> {{ translate('totalCharges') }}</mds-th>
            </mds-thead>
            <mds-tbody>
              <mds-tr
                v-for="item in annuityData"
                :key="item.policyId"
                :class="$style['hover-change']"
              >
                <mds-td> {{ item.policyName }} </mds-td>
                <mds-td right-aligned>
                  <!-- No policySetting set yet -->
                  <mds-button
                    v-if="!anyRiderSelected(item.policySetting)"
                    variation="flat"
                    @click="openDialog(item)"
                  >
                    {{ translate('select') }}
                  </mds-button>
                  <!-- policySetting set already -->
                  <span v-if="anyRiderSelected(item.policySetting)" :class="$style['notHover']">
                    {{ formatter.format(item.policySetting.totalFee, 'shortDecimal') }}
                  </span>
                  <span v-if="anyRiderSelected(item.policySetting)" :class="$style['hover']">
                    <mds-button variation="flat" @click="openDialog(item)">
                      {{ translate('edit') }}
                    </mds-button>
                  </span>
                </mds-td>
              </mds-tr>
            </mds-tbody>
          </mds-table>
        </div>
      </template>
    </mds-section>
    <annuity-dialog
      v-if="showDialog"
      :mwc-id="getMwcIdForChild('annuity-dialog')"
      :policy-info="currentDialogPolicy"
      @dialog-saved="handleDialogSave"
      @dialog-cancelled="showDialog = false"
    ></annuity-dialog>
  </div>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import MdsSection from '@mds/section';
import MdsSwitch from '@mds/switch';
import { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd } from '@mds/data-table';
import { MdsButton } from '@mds/button';
import cloneDeep from 'lodash.clonedeep';
import isEqual from 'lodash.isequal';
import AnnuityDialog from './AnnuityDialog';

export default {
  name: 'annuity-options',
  components: {
    MdsSection,
    MdsSwitch,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsButton,
    AnnuityDialog,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  props: {
    annuitySetting: {
      type: Object,
    },
    annuityDataProp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      includeAnnuity: false,
      showDialog: false,
      currentDialogPolicy: null,
      annuityData: [],
    };
  },
  computed: {},
  watch: {
    annuitySetting: {
      handler() {
        this.syncAnnuitySetting();
      },
      deep: true,
    },
    annuityDataProp: {
      handler() {
        this.syncAnnuityData();
      },
      deep: true,
    },
    includeAnnuity: {
      handler(val) {
        if (val) {
          this.$emit('include-switched-on', this.annuityData);
        } else {
          this.$emit('include-switched-off');
        }
      },
    },
  },
  created() {
    this.syncAnnuitySetting();
    this.syncAnnuityData();
  },
  methods: {
    syncAnnuitySetting() {
      this.includeAnnuity = this.annuitySetting.includeAnnuity;
    },
    syncAnnuityData() {
      this.annuityData = cloneDeep(this.annuityDataProp);
    },
    openDialog(policy) {
      this.showDialog = true;
      this.currentDialogPolicy = policy;
    },
    handleDialogSave(policySetting) {
      this.showDialog = false;
      if (!isEqual(this.currentDialogPolicy?.policySetting, policySetting)) {
        this.currentDialogPolicy.policySetting = policySetting;
        this.$emit('annuity-updated', this.annuityData);
      }
    },
    anyRiderSelected(policySetting) {
      // totalFee exist only when at least one rider selected
      return policySetting && policySetting.totalFee >= 0;
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/typography';

.annuity-explanation {
  @include mds-body-text-s();
  margin: 0;
}

.annuity-options-table {
  margin-top: $mds-space-2-x;
  max-height: 173px;
  overflow-y: auto;
  .mds-th__inner {
    margin-bottom: 0;
  }
}

.hover-change {
  .mds-button {
    margin-top: -5px;
    margin-right: $mds-space-quarter-x;
    padding: 1px;
    color: $mds-interactive-color-primary-default;
  }
  .notHover {
    display: inline-block;
  }
  .hover {
    display: none;
  }
}

.hover-change:hover {
  background-color: #53aaec1a;
  .mds-button {
    color: $mds-interactive-color-primary-default;
  }
  .notHover {
    display: none;
  }
  .hover {
    display: inline-block;
  }
}
</style>
